import request from '@/plugins/request';
import { TicketStatus } from '@/types/enums';
import { ITicket } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/tickets';

export interface IGetRequest {
  userName: string;
  status: TicketStatus;
  ticketNo: string;
  keyword: string;
  offset: number;
  limit: number;
}

export interface IGetResult {
  count: number;
  tickets: ITicket[];
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
